module.exports = __webpack_public_path__ + "img/nothing-in-notes.b017870e.svg";